const appName = "Prijavni sistem 404";
const drawerWidth = 260;
const appBarHeightDesktop = 64;
const appBarHeightMobile = 56;

const debug = process.env.REACT_APP_DEBUG !== "false";

const reCaptchaKey = "6LfVCLUZAAAAACzx7Fus8w2xANuuAYWS-ddEnn-U";

const termsUrl = "https://404.si/pogoji-poslovanja/";
const privacyUrl = "https://404.si/politika-zasebnosti/";

const apiUrl = process.env.REACT_APP_API_URL;

// PostHog. The project API key is public (it can only write events). Analytics is
// a no-op when the key is unset, so local development does not pollute the
// project. The host is the EU cloud ingestion endpoint — note the `i.`, the bare
// eu.posthog.com is the dashboard. Change this line for another region.
const posthogKey = process.env.REACT_APP_POSTHOG_KEY;
const posthogHost = "https://eu.i.posthog.com";

const stripeTestKeyZavod =
  "pk_test_51H2CvZC7R3CCh0EWWXhqypTmGDGtnBpItcULazOrEkvpa8L0i5ajSmyzVdNdN9Ra37QBLltL6VViEvWK4oQnDXNj00hVcZBNEX";
const stripeTestKeyDrustvo =
  "pk_test_51HEZIMLWjNxqflweWcqBNehx2PsU32SwE0Hc3EBQbLCAa9MNOEmqQJdJZi0vRTl5O8NfND4dis1zcxmJuIKolAuw00lsy6v9DB";

const stripeProductionKeyZavod =
  "pk_live_51H2CvZC7R3CCh0EWrcsKQFu6wLiW3sewVfh0VO6ZLNjCKhBIXVbNS04ODfHYmxE6BuPEa8kRSMesHqqjNcQl0aIK006u3sHtY9";
const stripeProductionKeyDrustvo =
  "pk_live_51HEZIMLWjNxqflwewTJ4a1F0W24KmY7rP0WBaSagO742BF9YtKHlw8JuVvZ8xIWZ7dCA3szuizKfh9tSE6lCRFpF0063mYqkzm";

const stripeKeyZavod = debug ? stripeTestKeyZavod : stripeProductionKeyZavod;
const stripeKeyDrustvo = debug
  ? stripeTestKeyDrustvo
  : stripeProductionKeyDrustvo;

const organiser = {
  zavod_404: "zavod_404",
  drustvo_404: "drustvo_404",
};

const bankDetails = {
  zavod_404: {
    bankAccount: "SI56 0400 1005 0184 976",
    bankName: "NOVA KBM d.d.",
    companyName: "Zavod 404",
    companyAddress: "Mencingerjeva ulica 7, 1000 Ljubljana",
  },
  drustvo_404: {
    bankAccount: "SI56 6100 0001 6180 141",
    bankName: "DELAVSKA HRANILNICA d.d.",
    companyName: "Društvo 404",
    companyAddress: "Mencingerjeva ulica 7, 1000 Ljubljana",
  },
};

export {
  debug,
  apiUrl,
  posthogKey,
  posthogHost,
  appName,
  drawerWidth,
  appBarHeightDesktop,
  termsUrl,
  reCaptchaKey,
  appBarHeightMobile,
  privacyUrl,
  stripeKeyZavod,
  stripeKeyDrustvo,
  bankDetails,
  organiser,
};
